import { render, staticRenderFns } from "./OrderTransferForm.vue?vue&type=template&id=0c31b8ae&scoped=true&"
import script from "./OrderTransferForm.vue?vue&type=script&lang=js&"
export * from "./OrderTransferForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransferForm.vue?vue&type=style&index=0&id=0c31b8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31b8ae",
  null
  
)

export default component.exports